'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$PlanCode$() {
  this.c8l = null;
  this.c8m = false;
  this.c8j = null;
  this.c8k = false;
  this.Ys = null;
  this.c8i = null;
  this.c8h = null;
  $n_Lpresto_types$PlanCode$ = this;
  this.Ys = ($m_Lpresto_types$PlanCode$(), "freemium_2fa");
  this.c8i = ($m_Lpresto_types$PlanCode$(), "presto_sign");
  this.c8h = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Set$().ku($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_T.r().C)([this.c8i])));
}
export { $c_Lpresto_types$PlanCode$ as $c_Lpresto_types$PlanCode$ };
$p = $c_Lpresto_types$PlanCode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$PlanCode$;
/** @constructor */
function $h_Lpresto_types$PlanCode$() {
}
export { $h_Lpresto_types$PlanCode$ as $h_Lpresto_types$PlanCode$ };
$h_Lpresto_types$PlanCode$.prototype = $p;
$p.cI9 = (function() {
  if ((!this.c8m)) {
    this.c8l = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c8m = true;
  }
  return this.c8l;
});
$p.ads = (function() {
  if ((!this.c8k)) {
    this.c8j = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c8k = true;
  }
  return this.c8j;
});
var $d_Lpresto_types$PlanCode$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$PlanCode$, "presto.types$PlanCode$", ({
  a0K: 1,
  D: 1
}));
export { $d_Lpresto_types$PlanCode$ as $d_Lpresto_types$PlanCode$ };
var $n_Lpresto_types$PlanCode$;
function $m_Lpresto_types$PlanCode$() {
  if ((!$n_Lpresto_types$PlanCode$)) {
    $n_Lpresto_types$PlanCode$ = new $c_Lpresto_types$PlanCode$();
  }
  return $n_Lpresto_types$PlanCode$;
}
export { $m_Lpresto_types$PlanCode$ as $m_Lpresto_types$PlanCode$ };
//# sourceMappingURL=presto.types$-Plan-Code$.js.map
